import React from 'react';

/**
 * Landing page for the mobile sign-in link (/app/auth?t=…) when the RHWB Pulse
 * app did not intercept it — the app isn't installed, or the email was opened
 * on a computer. It deliberately does NOT sign in on the web: the token stays
 * unspent so the same link still works when tapped on the phone.
 */
const MobileAuthLink: React.FC = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
    <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-gray-200 max-w-md w-full text-center">
      <div className="bg-blue-100 rounded-full p-4 mb-6 inline-block">
        <svg className="h-8 w-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Open on your phone</h2>
      <p className="text-gray-600 mb-4">
        This sign-in link is for the RHWB Pulse app. Tap it from the email on the phone where the app is installed.
      </p>
      <p className="text-gray-600 mb-6">
        Or open the app and enter the 6-digit code from the same email.
      </p>
      <button
        onClick={() => window.location.replace('/')}
        className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4 rounded-lg font-medium hover:from-blue-700 hover:to-purple-700 transition-all duration-200"
      >
        Sign in on the web instead
      </button>
    </div>
  </div>
);

export default MobileAuthLink;
